import 'core-js/stable';
import 'regenerator-runtime/runtime';

const getParameterByName = require('../../lib/getParameterByName');

export default function initialise({ArticleStore, ArticleView, config = {}, templates = {}, customIsInEditor}) {
    if (!document.body.querySelector('article[data-design]')) {
        console.debug('No Axel generated article found. Stop initialise');
        return;
    }

    const safeConfig = {classNames: {}, selectors: {}, msg: {}, ...config};
    let isInEditor = !!(window.PB && window.PB.$ && (getParameterByName('pbScope') || getParameterByName('pbEditor')));

    const initArticle = () => {
        try {
            const articleDataSource = new ArticleStore({...safeConfig, isInEditor}).initiate();
            window.articleView = new ArticleView(articleDataSource, {...safeConfig, isInEditor}, templates);
            window.articleView.initiate();
        } catch (e) {
            console.debug("Article couldn't be initialized: " + e);
        }
    };
    // note that PB provides its own boolean - something like editMode: true. But it emerges much later after everything is inited so can't rely on that at this time.
    if (typeof customIsInEditor !== 'undefined') {
        isInEditor = customIsInEditor;
        if (location.href.includes('pbEdit=true') && !isInEditor) return;
        initArticle();
    } else if (isInEditor) {
        window.PB.$(document.documentElement).one('EnteredDesignMode', () => {
            initArticle();
        });
    } else {
        initArticle();
    }
}
